// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"ce1b3404","79":"1a739840","269":"17f153ac","273":"7847afdc","745":"5daef3eb","818":"bbe696c2","922":"9a797f7c"}[chunkId] + ".chunk.js";
};